<div class="flex flex-col justify-center gap-4">
  <div class="border-1 flex w-full flex-col justify-start gap-3 rounded-2xl border border-neutral-5 p-5 xs:gap-4 sm:gap-6 lg:gap-8">
    <span class="-mb-2 font-semibold">
      {{ 'lost-2fa-verify.description.label' | translate }}
    </span>
    <div>
      {{ 'lost-2fa-verify.description' | translate }}
    </div>
    <span class="-mb-2 font-semibold">
      {{ 'lost-2fa-verify.code.label' | translate }}
      <span class="text-negative-100">*</span>
    </span>
    <pay-lib-pin-entry (valueEntered)="setCode($event)" [pinCount]="6" />
    <pay-button-primary (click)="submit()">
      {{ 'lost-2fa-verify.submit.button' | translate }}
    </pay-button-primary>
  </div>
  <div class="flex gap-3 self-center">
    <span class="text-center text-neutral-80">
      <span class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="returnToLogin()">
        {{ 'reset-password.back-login.label' | translate }}
      </span>
    </span>
  </div>
</div>
